import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import RoomIcon from '@mui/icons-material/Room';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

// ... (other imports and styling)

const isCorporateMode = process.env.REACT_APP_CORPORATE_MODE === 'true';

const Footer = () => {
    if (isCorporateMode) {
        return (
            <div style={{ marginTop: '40px', padding: '10px' }}>
                <Grid container spacing={1} justifyContent="center" alignItems="center">
                    {/* Corporate Mode: Only Email icon */}
                    <Grid item xs={12}>
                        <Typography variant="body2" color="textSecondary" align="center" sx={{ fontSize: '10px' }}>
                            <Link href="mailto:hr@brimmatech.com" style={{ color: '#ffffff' }}>
                                <MailOutlineIcon />
                            </Link>
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body2" color="textSecondary" align="center" style={{ color: '#ffffff', fontSize: '10px' }}>
                            © {new Date().getFullYear()} TalentSculptors
                        </Typography>
                    </Grid>
                </Grid>
                <br />
            </div>
        );
    }

    return (
        <div style={{ marginTop: '40px', padding: '10px' }}>
            <Grid container spacing={1} justifyContent="center" alignItems="left">
                {/* Row 1: Linked icon and address */}
                <Grid item xs={6}>
                    <Typography variant="body2" color="textSecondary" align="right" sx={{ fontSize: '10px' }}>
                        <Link href="https://www.linkedin.com/company/talents-sculptors-llp/" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff' }}>
                            <LinkedInIcon /> {/* Add your linked icon here */}
                        </Link>
                    </Typography>
                </Grid>

                {/* Row 2: Gmail icon and address */}
                <Grid item xs={6}>
                    <Typography variant="body2" color="textSecondary" align="left" sx={{ fontSize: '10px' }}>
                        <Link href="mailto:mentorshipcell@talentsculptors.com" style={{ color: '#ffffff' }}>
                            <MailOutlineIcon /> {/* Add your Gmail icon here */}
                        </Link>
                    </Typography>
                </Grid>

                {/* Row 3: Location icon and address */}
                <Grid item xs={12}>
                    <Typography variant="body2" color="textSecondary" align="center" style={{ color: '#ffffff', fontSize: '10px' }}>
                        <RoomIcon sx={{ fontSize: '12px' }} /> {/* Add your location icon here */}
                        New No. 163, Flat A-3, <br /> 1st Floor, Lloyds Road,<br /> Royapettah, Chennai-600014
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2" color="textSecondary" align="center" style={{ color: '#ffffff', fontSize: '10px' }}>
                        © {new Date().getFullYear()} TalentSculptors
                    </Typography>
                </Grid>
            </Grid>
            <br />
        </div>
    );
};

export default Footer;
